<template>
  <div
    class="rounded-full bg-[--filter-text-color] shadow-card clamp-p-2-3"
    :style="{
      '--filter-bg-color': props.markerColor.bg,
      '--filter-text-color': props.markerColor.text,
    }"
  >
    <TransitionMapFilterGrowHeight
      :visible="showFilterMenu"
      class="overflow-y-clip"
    >
      <AFilterCheckbox
        v-for="entry in filters"
        :key="entry.value"
        :name="entry.name"
        :label="entry.name"
        size="sm"
        class="clamp-pb-2-3"
        :modelValue="activeFilters.includes(entry.value)"
        @update:modelValue="toggleFilter(entry.value)"
      >
        <img
          :src="
            filterImagesCharacters[entry.value as DatasourceMapCharacter] ||
            filterImagesCharacters[imagesCharactersFallback]
          "
        />
      </AFilterCheckbox>
    </TransitionMapFilterGrowHeight>
    <div class="relative">
      <AIconButton
        :icon="showFilterMenu ? 'xmark' : 'ellipsis'"
        :ariaLabel="showFilterMenu ? 'Close filter menu' : 'Open filter menu'"
        variant="secondary"
        size="sm"
        @click="toggleFilterMenu"
      />
      <span
        class="absolute top-0 right-0 translate-y--25% translate-x-25% transition-transform ease-out-quad block ui-border border-[--filter-text-color] bg-[--filter-bg-color] clamp-w-5-6 clamp-h-5-6 rounded-full flex justify-center items-center pointer-events-none"
        :class="{
          'scale-0 ease-in-quad': showFilterMenu || !activeFilters.length,
        }"
      >
        <span class="text-body-xs">{{ activeFilters.length || 1 }}</span>
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
// TODO: make it work when there's too many to fit on the screen! Overflow scroll doesn't work since the tooltip then is invisible
import datasourceData from '@/auto-generated/datasources.json';
import { DatasourceMapCharacter } from '@/auto-generated/datasources.ts';
import { FilterType } from '@/composables/useMapFilter';

import {
  imagesCharactersFallback,
  filterImagesCharacters,
} from '@/composables/useMapLayers';

const props = defineProps<{
  filterName: FilterType; // the name of the datasource (so we can get the icon of each category)
  activeFilters: string[];
  markerColor: {
    bg: string;
    text: string;
  };
}>();

const emit = defineEmits(['update:activeFilters']);

// toggle filter menu
const showFilterMenu = ref(false);
const toggleFilterMenu = () => (showFilterMenu.value = !showFilterMenu.value);

// toggle filters
const toggleFilter = (filter: string) => {
  if (props.activeFilters.includes(filter)) {
    const newFilters = props.activeFilters.filter((f) => f !== filter);
    emit('update:activeFilters', newFilters);
  } else {
    emit('update:activeFilters', [...props.activeFilters, filter]);
  }
};
const clearFilters = () => emit('update:activeFilters', []);
defineExpose({ clearFilters });

const datasource = computed(() => datasourceData.datasources[props.filterName]);
const filters = computed(() => datasource.value.entries);
</script>

<style scoped lang="scss">
.filters-enter-active,
.filters-leave-active {
  @apply ease-in-quad;
  transition: all 500ms;
}

.filters-enter-from,
.filters-leave-to {
  opacity: 0;
  transform: translateY(20px);
}
</style>
